import ManageUploadFile from "../pages/ManageImport/index.jsx";
import PatientSystemConfig from "../pages/PatientSysConfig";
import UpdatePassword from "../pages/auth/Profile/UpdatePassword.jsx";
import ManagePatientVitalChangeHistory from "../pages/dashboard/Components/ManagePatientVitalHistory/index.jsx";
import ContactHistory from "../pages/dashboard/Components/WellnessContactHistory/contactHistory.jsx";
import Dashboard from "../pages/dashboard/GraphAndHistoricalData/index.jsx";
import ViewPatient from "../pages/dashboard/index.jsx";

export const ComponentsBasedOnRole = {
    "patient-user":
    [
        {
            name  : 'SystemConfig',
            element: <PatientSystemConfig/>,
            path : '/',
            roleKey : 'profile'
        },
        {
            name  : 'SystemConfig',
            element: <PatientSystemConfig/>,
            path : '/profile',
            roleKey : 'profile'
        },
        {
            name  : 'UpdatePassword',
            element: <UpdatePassword/>,
            path : '/profile/update-password',
            roleKey : 'UpdatePassword'
        },
        {
            name  : 'Dashboard',
            element: <ViewPatient/>,
            path : '/dashboard/view-details/:id',
            roleKey : 'Dashboard'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientVitalChangeHistory/>,
            path:'/dashboard/monitoring-condition-changes/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Dashboard',
            element: <Dashboard/>,
            path : '/dashboard',
            roleKey : 'Dashboard'
        },
        {
            name:'Manage Patients',
            element:<ContactHistory />,
            path:'/dashboard/view-details/contact-history/:id/:patientId',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Upload File',
            element: <ManageUploadFile/>,
            path : '/upload-file',
            roleKey : 'Upload-File'
        },

    ],
    "observer":
    [
        {
            name  : 'SystemConfig',
            element: <PatientSystemConfig/>,
            path : '/',
            roleKey : 'profile'
        },
        {
            name  : 'SystemConfig',
            element: <PatientSystemConfig/>,
            path : '/profile',
            roleKey : 'profile'
        },
        {
            name  : 'UpdatePassword',
            element: <UpdatePassword/>,
            path : '/profile/update-password',
            roleKey : 'UpdatePassword'
        },
        {
            name  : 'Dashboard',
            element: <ViewPatient/>,
            path : '/dashboard/view-details/:id',
            roleKey : 'Dashboard'
        },
        {
            name:'Manage Patients',
            element:<ManagePatientVitalChangeHistory/>,
            path:'/dashboard/monitoring-condition-changes/:id',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Dashboard',
            element: <Dashboard/>,
            path : '/dashboard',
            roleKey : 'Dashboard'
        },
        {
            name:'Manage Patients',
            element:<ContactHistory />,
            path:'/dashboard/view-details/contact-history/:id/:patientId',
            roleKey : 'Manage-Patients'
        },
        {
            name  : 'Upload File',
            element: <ManageUploadFile/>,
            path : '/upload-file',
            roleKey : 'Upload-File'
        },
  
    ]
}